import React, { useState } from 'react'
import { Box, Typography, Button, CircularProgress } from '@mui/material'

import useCurrentTeacher from 'common/context/TeacherContext'
import api from 'common/services/api'

function SigninConfirmation() {
  const { currentTeacher } = useCurrentTeacher()
  const [loading, setLoading] = useState(false)

  const handleCancel = () => {
    const closeButton = window.parent.document.querySelector(
      '#awakeningSigninConfirmationPopup .closeIcon'
    ) as HTMLElement
    closeButton.click()
  }
  const handleConfirm = () => {
    setLoading(true)
    api({
      url: '/api2/teacher/launch-legends',
      method: 'POST',
      data: {
        tCode: currentTeacher.code,
        tSecret: currentTeacher.getSecret(),
      },
    })
      .then((response) => {
        window.parent.location.href = response.data.joinUrl
      })
      .catch((error) => {
        console.log('error', error)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  return (
    <Box>
      <Box
        sx={{
          width: '600px',
          height: '200px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          variant='h5'
          sx={{
            mb: 4,
            fontSize: '1.5rem',
          }}
        >
          Confirm Redirect
        </Typography>

        <Typography
          variant='body1'
          sx={{
            mb: 1,
          }}
        >
          You are about to leave XtraMath and be redirected to the Awakening
          App. <br />
          Please confirm that you wish to proceed.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
            mt: 'auto',
          }}
        >
          <Button onClick={handleCancel} variant='text' color='error'>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant='text'
            sx={{ color: 'common.black' }}
          >
            {loading ? <CircularProgress size={20} /> : 'Confirm'}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default SigninConfirmation
